import { render, staticRenderFns } from "./nhiaDialog.vue?vue&type=template&id=c36ba034&"
import script from "./nhiaDialog.vue?vue&type=script&lang=js&"
export * from "./nhiaDialog.vue?vue&type=script&lang=js&"
import style0 from "./nhiaDialog.vue?vue&type=style&index=0&id=c36ba034&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports